export default {
    summary_text: 'Su resumen de EcoCredits',
    membership: 'MIEMBRO',
    current_tier: 'Nivel actual',
    points: 'EcoCredits',
    points_balance: 'Saldo de EcoCredits',
    points_progress_tips: 'EcoCredits necesarios para alcanzar {plus}: {points} EcoCredits',
    coming_soon: 'Próximamente',
    redeem_now: 'CANJEAR AHORA',
    points_activity: 'ACTIVIDAD DE PUNTOS',
    how_it_works: 'Cómo funciona',
    already_member: '¿Ya es miembro?',
    already_member1: '¿Ya es miembro?',
    sign_up: 'Registrarse',
    sign_up_desc: 'Cree una cuenta y consiga 500 EcoCredits de recompensa.',
    sign_up_desc_h: '500 EcoCredits cuando se inscriba.',
    earn_points: 'GANE EcoCredits',
    earn_points_desc: 'Gane EcoCredits con cada compra.',
    redeem_points: 'CANJEAR EcoCredits',
    redeem_points_desc: 'Canjee EcoCredits por descuentos exclusivos.',
    earn_points_title: 'Formas de ganar EcoCredits',
    sign_up_text: '500 EcoCredits al inscribirse',
    completed_text: 'Ya consiguió esta recompensa.',
    subscribe: 'Suscribirse',
    subscribe_capital_letters: 'Suscribirse',
    subscribe_text: 'Suscríbase al boletín de EcoFlow.',
    subscribe_hover: 'Gane 500 EcoCredits al suscribirse.',
    subscribe_now: 'Suscribirse ahora',
    email_address: 'Dirección de correo electrónico',
    shop: 'Tienda',
    shop_capital_letters: 'Tienda',
    earn_point_by_order: 'Gane cada vez que haga un pedido.',
    earn_point_rule_shop: 'Consiga 1 EcoCredit por cada $ 1 que gaste.',
    shop_to_earn_points: 'Compre para ganar EcoCredits',
    warranty: 'Garantía',
    warranty_capital_letters: 'Garantía',
    warranty_desc1: '1000 EcoCredits cuando registre un producto.',
    warranty_desc2: '1000 EcoCredits cuando registre un producto.',
    profile: 'Perfil',
    profile_desc1: 'Gane hasta 1000 EcoCredits por completar su perfil.',
    profile_desc2: 'Gane hasta 1000 EcoCredits por agregar sus datos.',
    complete_profile: 'Completar perfil',
    referral: 'Invitar a un amigo',
    referral_desc: 'Gane EcoCredits por cada amigo que se registre.',
    referral_btn: 'Únase ahora',
    redeem_ecocredits_title: 'Canjear recompensas de EcoCredits',
    have_points: 'Tiene <code>{points} EcoCredits</code>',
    view_all: 'Ver todo',
    coupon: 'Código de descuento',
    discount: 'Descuento',
    gift_card: 'Tarjeta de regalo',
    redeemed_succ: 'Canjeado correctamente',
    copy_desc: 'Copió el código. Vaya a la tienda para usarlo.',
    store: 'Comprar ahora',
    coupon_used_desc: 'Utilice este código al pagar para canjear su tarjeta de regalo de {amount}',
    rules: 'Reglas',
    off: 'DESCUENTO',
    site_rules: 'Solo para tienda de MX.',
    days_rules: 'Válido durante {days} días a partir del canje.',
    product_rules: 'Solo para {product}.',
    days_rules2: 'Válido a partir de {data}.',
    rewards_redeemed: 'Mis recompensas',
    lucky_rewards_list: 'Lista de recompensas',
    redeedmed_tab_name: 'Canjeado',
    issued_tab_name: 'Emitido',
    available: 'Disponible',
    redeemed: 'Canjeado',
    expired: 'Caducado',
    edeemed_rewards_note: 'Sus recompensas canjeadas aparecerán aquí.',
    browse_ecocredits_rewards: 'Ver recompensas de EcoCredits',
    used: 'Utilizado',
    give_away: 'Regalar',
    or_text: 'O',
    send_your_friend: 'Enviar su tarjeta de regalo de {amont} a un amigo.',
    points_activity_a: 'Mi actividad',
    points_tab_name: 'Actividad de EcoCredits',
    rewards_tab_name: 'Actividad de recompensas',
    date: 'Fecha',
    action: 'Acción',
    rewards_title: 'Recompensas',
    type_title: 'Tipo',
    discount_type: 'Descuento',
    purchase: 'Compra',
    profile_a: 'Perfil',
    refund: 'Reembolso',
    registered: 'Registrado',
    points_capital_letters: 'EcoCredits',
    status: 'Estado',
    pending: 'Pendiente',
    received: 'Recibido',
    deducted: 'Descontado',
    view_more: 'Ver más',
    history_note: 'Su actividad de EcoCredits aparecerá aquí. ¿Todavía no ve sus EcoCredits? Su actividad se actualizará dentro de 24 horas.',
    lucky_flop_start: 'Únase ahora',
    lucky_flop_congrat: 'Felicitaciones',
    lucky_flop_get: 'Reclamar',
    lucky_flop_open: 'ABRIR',
    ecoflow_benefits: 'Beneficios de EcoCredits',
    membership_includes: 'LA MEMBRESÍA INCLUYE',
    see_t_c: 'Ver términos y condiciones',
    manually_added: 'Agregado manualmente',
    manually_deducted: 'Deducido manualmente',
    faq_title: 'Preguntas frecuentes',

    redeeming_points: 'CANJE de EcoCredits',

    network_error: 'Error de red',
    confirm_text: '¿Está seguro de que desea canjear? No se puede deshacer.',
    confirm_btn: 'Confirmar',
    no_enough_points: 'Error de canje, sus EcoCredits no son suficientes',
    no_history_note: '¿Todavía no ve sus EcoCredits? Su actividad se actualizará en 24 horas.',
    no_coupon_note: 'Aún no se ha canjeado ninguna recompensa.',
    minimum_price: 'Importe mínimo de compra ({price}).',
    minimum_num: 'Cantidad mínima de artículos({num} uds.).',
    stay_too_long: 'Su sesión ha expirado. Actualice la página e inténtelo de nuevo.',
    order_rule: 'Solo un código de descuento por pedido.',
    purchas_rule: 'Si compra un artículo por un precio inferior al del cupón, perderá la diferencia.',
    profile_birthday: 'Perfil - Cumpleaños',
    profile_address: 'Perfil - Dirección',
    profile_username: 'Perfil - Nombre de usuario',
    profile_picture: 'Perfil - Foto',
    profile_contact: 'Perfil - Información de contacto',
    learn_more: 'Más información',
    profile_detail:
        'Complete su perfil para obtener hasta 1000 EcoCredits, lo que incluye foto de perfil (200), nombre de usuario (100), información de contacto (300), dirección (200) y cumpleaños (200).',
    exceeded_counts: 'No se pudo canjear. Ha superado el límite de canje.',
    grab_title: 'Obtenga una bonificación de EcoCredits',
    grab_sub_title: 'Ofertas exclusivas por tiempo limitado para miembros de EcoCredit. Haga clic para canjear ahora',
    grab_btn_text: 'Obtener mi bonificación',
    grab_success_title: 'Felicitaciones',
    grab_success_text1: 'Ha conseguido su bonificación\nPegue el código al comprar para obtener su descuento.',
    grab_success_text2: 'Check your bonuses in <code>My Rewards</code>.',
    'no-grab-content-note': 'Próximamente habrán más ofertas',
    copy_desc_2: 'Ha copiado el código.',
    city_validatino_error: 'Ciudad no válida',
    product_text: 'Producto',
    shipping_address_text: 'Dirección de envío',
    saved_address_text: 'Direcciones guardadas',
    use_new_address: 'utilizar una nueva dirección',
    spend_now: 'Gastar ahora',
    stock_left: '{stock} restante',
    no_stock_tip: 'Próximamente… Esté atento.',
    order_text: 'Pedido',
    campaign_time_limit_text: 'Período de canje válido: {startTime} - {endTime}.',
    event_action_text: 'Evento',
    warranty_minus_action_text: 'WGarantía eliminada',
    question_correctly: 'Responda correctamente a la pregunta',
    referral_correctly: 'Programa de recomendación',
    confirm_btn_text: 'Cerrar',
    member_only_title: 'Membe-Only prices products',
    member_only_subtitle: 'Unlock member-only rewards',
    member_only_off: 'DESCUENTO',
    member_only: 'Solo miembros',
    member_only_non: 'Non-member price',
    member_only_link: 'Browse the Entire Sale',
    member_only_prices: 'Member-Only Prices',
    lucky_turntable_title: 'Tirada de la suerte',
    join_lucky_with_points: 'Una partida de tirada de la suerte cuesta {points} EcoCredits.',
    join_lucky_with_points2: 'Una partida cuesta {points} EcoCredits.',
    join_lucky_desc: '¡Gire la rueda y gane un premio!',
    remaining_number: '<code></code> giros restantes',
    remaining_number2: '<code></code> vueltas restantes',
    learn_lucky_rule: 'Conozca más sobre las reglas',
    prize_coupon_title: 'Felicitaciones',
    prize_coupon_sub_title: '¡El premio ha sido reclamado con éxito! Utilice el código al pagar para ahorrar.',
    prize_coupon_action: 'Vea sus premios en <code>Mis premios</code>.',
    prize_coupon_button: 'Comprar ahora',
    prize_points_title: 'Felicitaciones',
    prize_points_desc: 'Compruebe los EcoCredits recién agregados en <code>Mi Actividad</code>.',
    limit_times_in_day: 'Puede girar las ruletas <count></count> veces en <day></day> días.',
    limit_times_in_day2: 'Puede voltear las cartas <count></count> veces en <day></day> días',
    limit_times_in_active: 'Durante el evento, puede girar las ruletas hasta <count></count> veces.',
    limit_times_in_active2: 'Durante el evento, puede voltear las cartas hasta <count></count> veces.',
    without_limit_times: 'Puede girar las ruedas <count></count> veces en cualquier momento.',
    without_limit_times2: 'Puede voltear las cartas <count></count> veces en cualquier momento.',
    active_is_unstart: 'Este evento se celebrará próximamente.',
    active_is_ended: 'Este evento ha finalizado.',
    over_max_count: 'Ha superado el número de giros disponibles.',
    notice_title: 'Aviso',
    points_cash: 'Canje de puntos',
    Pending1: 'Pendiente',
    rollback: 'Devuelto',
    level_change_log: 'Nivel de actividad',
    deadline: 'Válido hasta',
    history_refresh_member: 'Nivel actual: Miembro',
    history_refresh_plus_member: 'Nivel actual: Miembro PLUS',
    register: 'Registrarse como miembro',
    upgrade: 'Cambiar a Miembro PLUS',
    demotion: 'Cambiar a Miembro',
    relegation: 'Mantenerse como Miembro PLUS',
    ecocredits_notice1:
        'Hemos actualizado las normas de los EcoCredits el 17 de octubre de 2024. Lea atentamente nuestras [<line1>Normas de EcoCredits</line1>] actualizadas antes de utilizar sus EcoCredits.',
    wattayear_2024: 'Compartir#WattAYear',
    site_account_profile_save_success: 'Éxito',
    not_eligible: 'No aplica para participar en este evento.',

    // FAQ
    faq_tab_all: 'Todas las preguntas',
};
